// import React, { memo, useEffect, useState } from "react";
// import { Layout, Menu } from "antd";
// import { useNavigate, useLocation } from "react-router-dom";
// import { ReactComponent as Apps } from "../../assets/svgs/apps.svg";
// import { ReactComponent as Group } from "../../assets/svgs/group.svg";
// import { ReactComponent as Customer } from "../../assets/svgs/customer.svg";
// import { ReactComponent as Project } from "../../assets/svgs/project.svg";
// import { ReactComponent as Question } from "../../assets/svgs/question.svg";
// import { ReactComponent as License } from "../../assets/svgs/license_icon.svg";
// import { ReactComponent as Standard } from "../../assets/svgs/standard.svg";
// import { ReactComponent as Support } from "../../assets/svgs/support.svg";
// import { ReactComponent as CustomerReports } from "../../assets/svgs/reports.svg";
// import { ReactComponent as Settings } from "../../assets/svgs/settings.svg";
// import { ReactComponent as Reports } from "../../assets/svgs/reportss.svg";
// import { ReactComponent as Logo } from "../../assets/svgs/sidebarlogo.svg";
// import { ReactComponent as ContactUs } from "../../assets/svgs/contactUs.svg";
// import TextStyles from "../Elements/TextStyles/TextStyles";
// import { getApi } from "../../api/api_instance";
// import { API_URLS } from "../../api/apiUrls";

// const { Sider } = Layout;

// const MENU_ITEMS = [
//   {
//     key: "/",
//     label: "Dashboard",
//     icon: <Apps className="w-5 h-5" />,
//   },
//   {
//     key: "/group",
//     label: "Group",
//     icon: <Group className="w-5 h-5" />,
//   },
//   {
//     key: "/customer",
//     label: "Customer",
//     icon: <Customer className="w-5 h-5" />,
//   },
//   {
//     key: "/projects",
//     label: "Project",
//     icon: <Project className="w-5 h-5" />,
//   },
//   {
//     key: "/license",
//     label: "License",
//     icon: <License className="w-5 h-5" />,
//   },
//   {
//     key: "/question-bank",
//     label: "Question Bank",
//     icon: <Question className="w-5 h-5" />,
//   },
//   {
//     key: "/standard-forms",
//     label: "Standard Forms",
//     icon: <Standard className="w-5 h-5" />,
//   },
//   {
//     key: "/customer-reports",
//     label: "Customer Reports",
//     icon: <CustomerReports className="w-5 h-5" />,
//   },
//   {
//     key: "/support-ticket",
//     label: "Support Ticket",
//     icon: <Support className="w-5 h-5" />,
//   },
//   {
//     key: "/contact-us",
//     label: "Contact Us",
//     icon: <ContactUs className="w-5 h-5" />,
//   },
//   {
//     key: "/setting",
//     label: "Settings",
//     icon: <Settings className="w-5 h-5" />,
//     children: [
//       {
//         key: "/setting/roles",
//         label: "Roles and Permissions",
//       },
//       {
//         key: "/setting/users",
//         label: "Users",
//       },
//       {
//         key: "/setting/project-type",
//         label: "Project Type",
//       },
//       {
//         key: "/setting/Reports-Type",
//         label: "Reports Type",
//       },
//       {
//         key: "/setting/static-pages",
//         label: "Static Pages",
//       },
//     ],
//   },
//   {
//     key: "/footprint",
//     label: "Reports ",
//     icon: <Reports className="w-5 h-5" />,
//   },
// ];

// // Pure Component for Sidebar Logo
// const SidebarLogo = memo(() => (
//   <div className="flex justify-center">
//     <Logo className="w-32 h-32 mt-8" />
//   </div>
// ));

// const SidebarMenu = memo(({ items, onMenuClick, location, onParentClick }) => {
  
//   return (
//     <Menu
//       mode="inline"
//       className="custom-menu"
//       selectedKeys={[location.pathname]}
//       defaultOpenKeys={[location.pathname.split("/").slice(0, 3).join("/")]}
//       onClick={onMenuClick}
//       items={items.map((item) => {
//         if (item.children) {
//           return {
//             ...item,
//             label: (
//               <div
//                 onClick={() => onParentClick(item.key)}
//                 style={{ cursor: "pointer" }}
//               >
//                 <span>{item.label}</span>
//               </div>
//             ),
//             children: item.children.map((child) => {
//               const isActive = location.pathname === child.key;
//               return {
//                 ...child,
//                 label: (
//                   <div className={`flex items-center gap-2 `}>
//                     {/* <span className={isActive ? "gradient" : "text-gray-600"}>
//                       •
//                     </span> */}
//                     <TextStyles color={isActive ? "gradient" : "text-gray-600"}>
//                      <span>•</span> {child.label}
//                     </TextStyles>
//                   </div>
//                 ),
//               };
//             }),
//           };
//         }
//         return item;
//       })}
//     />
//   );
// });

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [filteredMenuItems, setFilteredMenuItems] = useState([])

//   const handleMenuClick = (e) => {
//     navigate(e.key);
//   };

//   const handleParentClick = (key) => {
//     if (key === "/setting") {
//       navigate("/setting/roles");
//     } else {
//       navigate(key);
//     }
//   };

//   useEffect(() => {
//     const fetchSideBarAccess = async () => {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_SIDEBAR_ACCESS,
//       });

//       if (response.success) {
//         const allowedResources = response.data
//           .filter((item) => item.view) // Optional: Only show items with `view: true`
//           .map((item) => item.resource_name);

//         const filtered = MENU_ITEMS.filter((menuItem) => {
//           // For parent menus with children, check both parent and child labels
//           if (menuItem.children) {
//             const filteredChildren = menuItem.children.filter((child) =>
//               allowedResources.includes(child.label)
//             );
//             return filteredChildren.length > 0;
//           }

//           return allowedResources.includes(menuItem.label);
//         }).map((menuItem) => {
//           if (menuItem.children) {
//             const filteredChildren = menuItem.children.filter((child) =>
//               allowedResources.includes(child.label)
//             );
//             return {
//               ...menuItem,
//               children: filteredChildren,
//             };
//           }
//           return menuItem;
//         });

//         setFilteredMenuItems(filtered);
//       }
//     };

//     fetchSideBarAccess();
//   }, []);

//   return (
//     <Sider width={300} className="bg-white min-h-screen ">
//       <SidebarLogo />

//       <SidebarMenu
//         // items={MENU_ITEMS}
//         items={filteredMenuItems}
//         location={location}
//         onMenuClick={handleMenuClick}
//         onParentClick={handleParentClick}
//       />
//     </Sider>
//   );
// };

// export default Sidebar;

import React, { memo, useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as Apps } from "../../assets/svgs/apps.svg";
import { ReactComponent as Group } from "../../assets/svgs/group.svg";
import { ReactComponent as Customer } from "../../assets/svgs/customer.svg";
import { ReactComponent as Project } from "../../assets/svgs/project.svg";
import { ReactComponent as Question } from "../../assets/svgs/question.svg";
import { ReactComponent as License } from "../../assets/svgs/license_icon.svg";
import { ReactComponent as Standard } from "../../assets/svgs/standard.svg";
import { ReactComponent as Support } from "../../assets/svgs/support.svg";
import { ReactComponent as CustomerReports } from "../../assets/svgs/reports.svg";
import { ReactComponent as Settings } from "../../assets/svgs/settings.svg";
import { ReactComponent as Reports } from "../../assets/svgs/reportss.svg";
import { ReactComponent as Logo } from "../../assets/svgs/sidebarlogo.svg";
import { ReactComponent as ContactUs } from "../../assets/svgs/contactUs.svg";
import TextStyles from "../Elements/TextStyles/TextStyles";
import { getApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";

const { Sider } = Layout;

const MENU_ITEMS = [
  {
    key: "/",
    label: "Dashboard",
    icon: <Apps className="w-5 h-5" />,
  },
  {
    key: "/group",
    label: "Group",
    icon: <Group className="w-5 h-5" />,
  },
  {
    key: "/customer",
    label: "Customer",
    icon: <Customer className="w-5 h-5" />,
  },
  {
    key: "/projects",
    label: "Project",
    icon: <Project className="w-5 h-5" />,
  },
  {
    key: "/license",
    label: "License",
    icon: <License className="w-5 h-5" />,
  },
  {
    key: "/question-bank",
    label: "Question Bank",
    icon: <Question className="w-5 h-5" />,
  },
  {
    key: "/standard-forms",
    label: "Standard Forms",
    icon: <Standard className="w-5 h-5" />,
  },
  {
    key: "/customer-reports",
    label: "Customer Reports",
    icon: <CustomerReports className="w-5 h-5" />,
  },
  {
    key: "/support-ticket",
    label: "Support Ticket",
    icon: <Support className="w-5 h-5" />,
  },
  {
    key: "/contact-us",
    label: "Contact Us",
    icon: <ContactUs className="w-5 h-5" />,
  },
   {
    key: "/subscribers",
    label: "Subscribers",
    icon: <Customer className="w-5 h-5" />,
  },
  {
    key: "/setting",
    label: "Settings",
    icon: <Settings className="w-5 h-5" />,
    children: [
      {
        key: "/setting/roles",
        label: "Roles and Permissions",
      },
      {
        key: "/setting/users",
        label: "Users",
      },
      {
        key: "/setting/project-type",
        label: "Project/Services",
      },
      {
        key: "/setting/licence-cost",
        label: "Licence Cost",
      },
      {
        key: "/setting/Reports-Type",
        label: "Reports Type",
      },
      {
        key: "/setting/static-pages",
        label: "Static Pages",
      },
    ],
  },
  {
    key: "/footprint",
    label: "Reports ",
    icon: <Reports className="w-5 h-5" />,
  },
 
];

// Pure Component for Sidebar Logo
const SidebarLogo = memo(() => (
  <div className="flex justify-center">
    <Logo className="w-32 h-32 " />
  </div>
));

const SidebarMenu = memo(({ items, onMenuClick, location, onParentClick }) => {
  return (
    <Menu
      mode="inline"
      className="custom-menu"
      selectedKeys={[location.pathname]}
      defaultOpenKeys={[location.pathname.split("/").slice(0, 3).join("/")]}
      onClick={onMenuClick}
      items={items.map((item) => {
          const isActive = location.pathname ===item.key;
        if (item.children) {
          return {
            ...item,
            label: (
              <div
                onClick={() => onParentClick(item.key)}
                style={{ cursor: "pointer" }}
                // color={isActive ? "gradient" : "text-gray-600"}
                className="text-black"
              >
                <span>{item.label}</span>
              </div>
            ),
            children: item.children.map((child) => {
              const isActive = location.pathname === child.key;
              return {
                ...child,
                label: (
                  <div className={`flex items-center gap-2 `}>
                    <TextStyles color={isActive ? "gradient" : "text-gray-600"}>
                      <span>•</span> {child.label}
                    </TextStyles>
                  </div>
                ),
              };    
            }),
          };
        }
        return item;
      })}
    />
  );
});

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);

  const handleMenuClick = (e) => {
    navigate(e.key);
  };

  const handleParentClick = (key) => {
    if (key === "/setting") {
      navigate("/setting/roles");
    } else {
      navigate(key);
    }
  };

  useEffect(() => {
    const fetchSideBarAccess = async () => {
      const response = await getApi({
        apiUrl: API_URLS.GET_SIDEBAR_ACCESS,
      });

      if (response.success) {
        const allowedResources = response.data
          .filter((item) => item.view)
          .map((item) => item.resource_name);

        const resourceMapping = {
          "Project/Services": ["Project Type", "Project"],
          "Licence Cost": ["Setting", "Settings"],
          "Subscribers": ["Customer"] // Map to Customer permission so admins can see it
        };

        const checkResource = (label) => {
          const mapped = resourceMapping[label] || label;
          if (Array.isArray(mapped)) {
            return mapped.some((resource) => allowedResources.includes(resource));
          }
          return allowedResources.includes(mapped);
        };

        const filtered = MENU_ITEMS.filter((menuItem) => {
          if (menuItem.children) {
            const filteredChildren = menuItem.children.filter((child) =>
              checkResource(child.label)
            );
            return filteredChildren.length > 0;
          }

          return checkResource(menuItem.label);
        }).map((menuItem) => {
          if (menuItem.children) {
            const filteredChildren = menuItem.children.filter((child) =>
              checkResource(child.label)
            );
            return {
              ...menuItem,
              children: filteredChildren,
            };
          }
          return menuItem;
        });

        setFilteredMenuItems(filtered);
      }
    };

    fetchSideBarAccess();
  }, []);

  return (
    <Sider 
      width={280} 
      className="bg-white fixed left-0 top-0 bottom-0 overflow-y-auto z-20"
      style={{ height: '100vh' }}
    >
      <SidebarLogo />

      <SidebarMenu
        items={filteredMenuItems}
        location={location}
        onMenuClick={handleMenuClick}
        onParentClick={handleParentClick}
      />
    </Sider>
  );
};

export default Sidebar;